<template>
  <section id="post" class="is-fullheight">
    <Navigation ref="foo"></Navigation>
    <div class="has-padding-y has-margin-top-60">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6">
            <div class="card-content">
              <h3 class="has-text-centered">{{ $t('post.post') }}</h3>
              <hr />
              <h5>{{ $t('post.details') }}</h5>
              <form @submit.prevent="validateBeforeSubmit">
                <div>
                  <b-field
                    :type="{'is-danger': errors.has('industry')}"
                    :message="errors.first('industry')">
                    <b-select 
                      v-model="post.industry"  
                      :placeholder="$t('post.input-ph-industry')"
                      v-validate="'required'"
                      name="industry"
                      expanded
                      class="has-margin-bottom-10">
                      <option value="audi-e-tron">{{ $t('post.input-option-audi-e-tron') }}</option>
                      <option value="citroen-berlingo">{{ $t('post.input-option-citroen-berlingo') }}</option>
                      <option value="ds-ds3-crossback-e-tense">{{ $t('post.input-option-ds-ds3-crossback-e-tense') }}</option>
                      <option value="hyundai-ioniq-electric">{{ $t('post.input-option-hyundai-ioniq-electric') }}</option>
                      <option value="hyundai-kona-electric-39-kwh">{{ $t('post.input-option-hyundai-kona-electric-39-kwh') }}</option>
                      <option value="hyundai-kona-electric-64-kwh">{{ $t('post.input-option-hyundai-kona-electric-64-kwh') }}</option>
                      <option value="jaguar-i-pace">{{ $t('post.input-option-jaguar-i-pace') }}</option>
                      <option value="kia-e-niro">{{ $t('post.input-option-kia-e-niro') }}</option>
                      <option value="mg-zs-ev">{{ $t('post.input-option-mg-zs-ev') }}</option>
                      <option value="nissan-e-nv200-combi-visia">{{ $t('post.input-option-nissan-e-nv200-combi-visia') }}</option>
                      <option value="nissan-e-nv200-visia">{{ $t('post.input-option-nissan-e-nv200-visia') }}</option>
                      <option value="nissan-leaf">{{ $t('post.input-option-nissan-leaf') }}</option>
                      <option value="peugeot-e-208">{{ $t('post.input-option-peugeot-e-208') }}</option>
                      <option value="peugeot-partner">{{ $t('post.input-option-peugeot-partner') }}</option>
                      <option value="renault-kangoo-crew-van-ze-33">{{ $t('post.input-option-renault-kangoo-crew-van-ze-33') }}</option>
                      <option value="renault-kangoo-panel-van-ze-33">{{ $t('post.input-option-renault-kangoo-panel-van-ze-33') }}</option>
                      <option value="renault-master-van-ze">{{ $t('post.input-option-renault-master-van-ze') }}</option>
                      <option value="renault-twizy">{{ $t('post.input-option-renault-twizy') }}</option>
                      <option value="renault-zoe">{{ $t('post.input-option-renault-zoe') }}</option>
                      <option value="smart-eq-forfour">{{ $t('post.input-option-smart-eq-forfour') }}</option>
                      <option value="smart-eq-fortwo-cabrio">{{ $t('post.input-option-smart-eq-fortwo-cabrio') }}</option>
                      <option value="smart-eq-fortwo-coupé">{{ $t('post.input-option-smart-eq-fortwo-coupé') }}</option>
                      <option value="tesla-model-3">{{ $t('post.input-option-tesla-model-3') }}</option>
                      <option value="tesla-model-s">{{ $t('post.input-option-tesla-model-s') }}</option>
                      <option value="tesla-model-x">{{ $t('post.input-option-tesla-model-x') }}</option>
                      <option value="volkswagen-e-golf">{{ $t('post.input-option-volkswagen-e-golf') }}</option>
                      <option value="volkswagen-e-up!">{{ $t('post.input-option-volkswagen-e-up!') }}</option>
                    </b-select>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('year')}"
                    :message="errors.first('year')">
                    <b-select 
                      v-model="post.year"  
                      :placeholder="$t('post.input-ph-year')"
                      v-validate="'required'"
                      name="year"
                      expanded
                      class="has-margin-top-40 has-margin-bottom-10">
                      <option value="2020">2020</option>
                      <option value="2019">2019</option>
                      <option value="2018">2018</option>
                      <option value="2017">2017</option>
                      <option value="2016">2016</option>
                      <option value="2015">2015</option>
                      <option value="2014">2014</option>
                      <option value="2013">2013</option>
                      <option value="2012">2012</option>
                      <option value="2011">2011</option>
                      <option value="2010">2010</option>
                    </b-select>
                  </b-field>
                  <b-field
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="number"
                      v-model.trim="post.odometer"
                      name="odometer"
                      expanded
                      :placeholder="$t('post.input-ph-odometer')"
                    ></b-input>

                    <b-select v-model="post.odometermetric">
                      <option selected="selected">Miles</option>
                      <option>Kms</option>
                    </b-select>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('range')}"
                    :message="errors.first('range')"
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="number"
                      v-model.trim="post.range"
                      name="range"
                      expanded
                      :placeholder="$t('post.input-ph-range')"
                    ></b-input>
                    <b-select v-model="post.rangemetric">>
                      <option selected>Miles</option>
                      <option>Kms</option>
                    </b-select>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('battery')}"
                    :message="errors.first('battery')"
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="number"
                      v-model.trim="post.battery"
                      name="battery"
                      expanded
                      :placeholder="$t('post.input-ph-battery')"
                    ></b-input>
                    <p class="control">
                      <span class="button is-static">kWh</span>
                    </p>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('charging')}"
                    :message="errors.first('charging')"
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="number"
                      v-model.trim="post.charging"
                      name="charging"
                      expanded
                      :placeholder="$t('post.input-ph-charging')"
                    ></b-input>
                    <p class="control">
                      <span class="button is-static">kW</span>
                    </p>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('acceleration')}"
                    :message="errors.first('acceleration')"
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="number"
                      step=".01"
                      v-model.trim="post.acceleration"
                      name="acceleration"
                      expanded
                      :placeholder="$t('post.input-ph-acceleration')"
                    ></b-input>
                    <p class="control">
                      <span class="button is-static">Seconds</span>
                    </p>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('condition')}"
                    :message="errors.first('condition')">
                    <b-select 
                      v-model="post.condition"  
                      :placeholder="$t('post.input-ph-condition')"
                      v-validate="'required'"
                      name="condition"
                      expanded
                      class="has-margin-top-40 has-margin-bottom-10">
                      <option value="New">{{ $t('post.input-option-new') }}</option>
                      <option value="Used">{{ $t('post.input-option-used') }}</option>
                    </b-select>
                  </b-field>

                  <b-field
                    :type="{'is-danger': errors.has('description')}"
                    :message="errors.first('description')">
                    <b-input
                      maxlength="120"
                      type="text"
                      v-model.trim="post.content"
                      name="description"
                      class="has-margin-top-40"
                      :placeholder="$t('post.input-ph-description')"
                    ></b-input>
                  </b-field>
                  <h5 class="has-margin-top-40 has-margin-bottom-10">{{ $t('post.pricing') }}</h5>
                  <div class="columns">
                    <div class="column is-4">
                      <b-field>
                        <b-select v-model="post.currency" expanded>
                          <option value="USD">USD</option>
                          <option value="GBP">GBP</option>
                          <option value="EUR">EUR</option>
                          <option value="AUD">AUD</option>
                          <option value="CAD">CAD</option>
                          <option value="JPY">JPY</option>
                          <option value="BRL">BRL</option>
                          <option value="INR">INR</option>
                          <option value="CNY">CNY</option>
                        </b-select>
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <b-field>
                        <div class="control is-clearfix">
                          <CurrencyInput
                            v-model="post.price"
                            v-validate="'required'"
                            :auto-decimal-mode="false"
                            :currency="post.currency"
                            :placeholder="$t('post.input-ph-price')"
                            class="input"
                            />
                        </div>
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <b-field>
                        <b-select 
                          v-model="post.pricetype" 
                          expanded>
                          <option value="fixed">{{ $t('post.input-option-fixed') }}</option>
                          <option value="negotiable">{{ $t('post.input-option-negotiable') }}</option>
                        </b-select>
                      </b-field>
                    </div>
                  </div>
                  <h5 class="has-margin-top-20">{{ $t('post.enquiries') }}</h5>
                  <b-field
                    :type="{'is-danger': errors.has('email')}"
                    :message="errors.first('email')">
                    <b-input
                      maxlength="20"
                      type="email"
                      name="email"
                      v-validate="'required'"
                      v-model.trim="post.email"
                      :placeholder="$t('post.input-ph-email')"
                    ></b-input>
                  </b-field>
                  <b-field>
                    <b-input
                      maxlength="12"
                      type="text"
                      v-model.trim="post.phone"
                      :placeholder="$t('post.input-ph-phone')"
                    ></b-input>
                  </b-field>
                  <h5 class="has-margin-top-20">{{ $t('post.carslocation') }}</h5>
                  <b-field
                    :type="{'is-danger': errors.has('country')}"
                    :message="errors.first('country')">
                    <b-select 
                      v-model="post.vehiclecountry"  
                      :placeholder="$t('post.input-ph-vehiclecountry')"
                      v-validate="'required'"
                      name="country"
                      expanded
                      class="has-margin-bottom-10">
                      <option value="USA">{{ $t('post.input-option-vehiclecountry-usa') }}</option>
                      <option value="Great Britian">{{ $t('post.input-option-vehiclecountry-greatbritan') }}</option>
                      <option value="Australia">{{ $t('post.input-option-vehiclecountry-australia') }}</option>
                      <option value="New Zealand">{{ $t('post.input-option-vehiclecountry-newzealand') }}</option>
                      <option value="Canada">{{ $t('post.input-option-vehiclecountry-canada') }}</option>
                      <option value="Ireland">{{ $t('post.input-option-vehiclecountry-ireland') }}</option>
                    </b-select>
                  </b-field>
                  <b-field
                    :type="{'is-danger': errors.has('location')}"
                    :message="errors.first('location')"
                    class="has-margin-top-40">
                    <b-input  
                      maxlength="10"
                      type="text"
                      v-model.trim="post.vehiclelocation"
                      v-validate="'required'"
                      name="location"
                      expanded
                      :placeholder="$t('post.input-ph-vehiclelocation')"
                    ></b-input>
                  </b-field>
                  <hr />

                  <h5>{{ $t('post.image-upload') }}</h5>
                  <p class="has-margin-bottom-10 has-text-centered">Upload up to {{ maxImages }} images</p>
                  <!-- if array length is not equal to maxImages (need to set) 
                  <div v-if="imagesList.length <= maxImages">
                    {{ imagesList.length }} of {{ maxImages }} Total Images
                  </div>-->
                  
                  <div v-if="imageError" class="has-text-brand">
                    <span class="has-text-danger">{{imageError}}</span>
                    <br />
                    {{ $t('post.image-please-adjust') }}
                    <hr />
                  </div>

                  <div v-for="(image, index) in imagesList" v-bind:key="image">
                    <div class="box has-margin-bottom-20">
                      <div class="columns">
                        <div class="column is-one-third">
                          <img v-bind:src=image.imageSetCropped alt="Image to save" class="has-rounded-3" />
                        </div>
                        <!-- {{ image.imageSetCropped.name }}-->
                        <div class="column">
                          <h5>Image {{ (index + 1) }}</h5>
                          <span v-if="image.imageUploadFile.name"
                            class="tag is-warning">
                            {{ image.imageUploadFile.name }}
                            <button class="delete is-small"
                              type="button"
                              @click="deleteFile()">
                            </button>
                          </span>
                          <hr />
                          <a @click="removeImageItem(index)"><i class="ri-close-line"></i> Remove</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="columns has-margin-botton-20 has-text-centered">
                    <div class="column">
                      <div v-if="imagesList.length > 0 && imagesList.length != maxImages" class="has-margin-bottom-10">
                        Uploaded another image:
                      </div>
                      <b-field v-if="imagesList.length == 0">
                        <b-upload v-model="post.file1" drag-drop accept="image/*" @input="selectedFile(post.file1)">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <i class="ri-upload-2-line ri-3x"></i>
                              </p>
                              <p>{{ $t('post.image-drop') }}</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                      <b-field v-else-if="imagesList.length == 1">
                        <b-upload v-model="post.file2" drag-drop accept="image/*" @input="selectedFile(post.file2)">
                          <section class="section">
                            <div class="content has-text-centered">
                              <p>
                                <i class="ri-upload-2-line ri-3x"></i>
                              </p>
                              <p>{{ $t('post.image-drop') }}</p>
                            </div>
                          </section>
                        </b-upload>
                      </b-field>
                    </div>
                  </div>

                  <!--<b class="has-text-success">imagesList: {{ imagesList }}</b><br />
                  <b-message type="is-primary">
                    {{ imagesUploadedList }}
                  </b-message>-->

                  <hr />
                  <button type="submit" class="button is-primary-grad is-rounded is-fullwidth"> {{ $t('post.button-publish') }} </button>
                  
                  <b-message type="is-warning has-box-shadow has-margin-top-40">
                    {{ $t('post.warning') }}
                  </b-message>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <b-modal :active.sync="showImageModal" :width="640" scroll="keep">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Adjust Image</p>
        </header>
        <section class="modal-card-body has-content-background">
          <div class="columns">
            <div class="column">
              <!--
              <div v-if="imageError" class="has-text-danger">
                {{imageError}}
              </div>-->
              <!--<div v-if="post.file">-->
              <vue-cropper
                ref='cropper'
                :guides="true"
                :view-mode="2"
                drag-mode="crop"
                :auto-crop-area="0.8"
                :min-container-width="250"
                :min-container-height="250"
                :background="true"
                :rotatable="true"
                :src="imgSrc"
                alt="Post Image"
                :img-style="{ 'width': '300px', 'height': '300px' }"
                :aspectRatio="1/1"
                :initialAspectRatio="1/1"
                :ready="initCropper"
              >
              </vue-cropper>
              <!--</div>-->
              <br />
              <div class="columns" v-if="imgSrc != ''">
                <div class="column">
                  <a @click="cropImage" class="button is-warning is-outlined is-fullwidth">{{ $t('post.button-crop') }}</a>
                </div>
                <div class="column">
                  <a @click="deleteFile()" class="button is-brand is-outlined is-fullwidth">{{ $t('post.button-clear') }}</a>
                </div>
              </div>

            </div>
            <div class="column" v-if="imgSrc != ''">
              <div v-if="cropImg != ''" class="box has-content-background">
                <img :src="cropImg" alt="Cropped Image" class="has-rounded-3" />
              </div>
              <!--
              <div v-if="cropImg1 != ''" class="box has-content-background">
                <img :src="cropImg1" alt="Cropped Image" class="has-rounded-3" />
              </div>
              -->
              <div v-else class="box has-content-background">
                {{ $t('post.image-upload-adjust') }}
              </div>
            </div>
            <div class="column" v-if="imgSrc != ''">
              <div v-if="cropImg != ''" class="has-text-brand">
                {{ $t('post.image-upload-confirmation') }}
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button @click="closeImageModal()" class="button is-success">Use Cropped Image</button>
          <button @click="deleteFile()" class="button">Don't Use Image</button>
        </footer>
      </div>
    </b-modal>

    <!-- /////////// -->
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
      <div id="spinner"></div>
    </b-loading>
  </section>
</template>

<script>
  import { mapState } from "vuex";
  import moment from "moment";
  const fb = require("../../firebaseConfig.js");
  import Navigation from '@/components/Navigation'
  //Image Cropper
  import VueCropper from 'vue-cropperjs';
  import '@/assets/scss/vendors/cropper/cropper.min.css';
  import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';

  export default {
    components: {
      VueCropper,
      Navigation
    },
    directives: { 
      vueFilterPrettyBytes
    },
    data() {
      return {
        post: {
          odometer: "",
          odometermetric: "Miles",
          range: "",
          rangemetric: "Miles",
          battery: "",
          charging: "",
          acceleration: "",
          content: "",
          vehiclelocation: "",
          price: "",
          currency: "USD",
          pricetype: "negotiable",
          industry: null,
          imageUrl: "",
          email: "",
          phone: "",
          status: "pending",
          imageUrl1: "",
          imageUrl2: ""
        },
        comment: {
          postId: "",
          userId: "",
          content: "",
          postComments: 0
        },
        showImageModal: false,
        showCommentModal: false,
        showPostModal: false,
        fullPost: {},
        dropFile: [],
        file: null,
        postComments: [],

        isLoading: false,
        isFullPage: "",

        image:{
          size:'',
          height:'',
          width:''
        },
        maxImages: 2,
        imageError:'',
        imgSrc:'',
        imgSrc2:'',
        cropImg: '',
        cropImgBlob: '',
        imageFile: null,
        imgSrcCropped: '',
        imagesList: [],
        imagesUploadedList: [],
      };
    },
    computed: {
      ...mapState(["userProfile", "currentUser", "posts", "hiddenPosts"])
    },
    methods: {
      validateBeforeSubmit() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.uploadFiles();
            return;
          }
          this.$toast.open({
            duration: 3000,
            message: this.$t("post.toast-form-invalid"),
            position: "is-bottom",
            type: "is-danger"
          });
          this.scrollTo();
        });
      },

      scrollTo() {
        var element = '#post';
        var duration = 300;
        var options = {
          easing: 'ease-in',
          offset: -80,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        this.$scrollTo(element, duration, options)
      },

      deleteFile() {
        this.post.file = null;
        this.imgSrc = "";
        this.imageFile = null;
        this.cropImg = "";

        this.showImageModal = false;

        let deleteImageIndex = (this.imagesList.length - 1);
        console.log("deleteImageIndex: " + deleteImageIndex);
        this.removeImageItem(deleteImageIndex);
      },

      removeImageItem: function(index) {
        console.log("remove index: " + index);
        this.imagesList.splice(index, 1);
      },

      closeImageModal(){
        this.showImageModal = false;
      },

      createPost() {
        fb.postsCollection
          .add({
            createdOn: new Date(),
            year: this.post.year,
            odometer: this.post.odometer,
            odometermetric: this.post.odometermetric,
            range: this.post.range,
            rangemetric: this.post.rangemetric,
            battery: this.post.battery,
            charging: this.post.charging,
            acceleration: this.post.acceleration,
            condition: this.post.condition,
            vehiclecountry: this.post.vehiclecountry,
            vehiclelocation: this.post.vehiclelocation,
            email: this.post.email,
            phone: this.post.phone,
            content: this.post.content,
            price: this.post.price,
            currency: this.post.currency,
            pricetype: this.post.pricetype,
            industry: this.post.industry,
            userId: this.currentUser.uid,
            userName: this.userProfile.name,
            userEmail: this.currentUser.email,
            //imageUrl: downloadURL,
            imageUrl1: this.post.imageUrl1,
            imageUrl2: this.post.imageUrl2,

            status: this.post.status,
            comments: 0,
            likes: 0
          })
          .then(post => {
            post.title = "";
            post.content = "";
            post.price = "";
            post.currency = "";
            post.pricetype = "";
            post.phone = "";
            post.email = "";
            post.year = "";
            post.odometer = "";
            post.range = "";
            post.battery = "";
            post.charging = "";
            post.acceleration = "";
            post.industry = "";
            post.vehiclelocation= "";

            this.snackbarSuccess();
            this.isLoading = false;
            this.$router.push("/postconfirmation");
          })
          .catch(err => {
            console.log(err);
            this.snackbarError();
            this.isLoading = false;
          });
      },

      selectedFile(postFileIncrement) {
        const imageMaxSize = 150000;
        const imageMaxWidth = 1000;
        const imageMaxHeight = 800;
        this.imageError = '';
        this.imgSrc = "";
        /*
        this.imageFile = this.post.file;
        let file = this.post.file;
        */
        this.imageFile = postFileIncrement;
        let file = postFileIncrement;

        this.imagesList.push({ imageUploadFile: postFileIncrement });
            
        console.log("selected file size: " + file.size);
        
        if(!file || file.type.indexOf('image/') !== 0) return;

        this.image.size = file.size;
        if(this.image.size > imageMaxSize) {
          let maxSizeCurrent = this.$options.filters.prettyBytes(imageMaxSize)
          let imageSizeCurrent = this.$options.filters.prettyBytes(this.image.size)
          this.imageError =  `The uploaded image size (${imageSizeCurrent}) is too big (max is ${maxSizeCurrent}).`;
          //this.imageError = `The image size (${this.image.size}) is too much (max is ${imageMaxSize}).`;
          this.deleteFile();
          return;
        }

        if (typeof FileReader === 'function') {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = evt => {
            let img = new Image();
            img.onload = () => {
              this.image.width = img.width;
              this.image.height = img.height;
              if(this.image.width > imageMaxWidth) {
                this.imageError = `The image width (${this.image.width}) is too much (max is ${imageMaxWidth}).`;
                this.deleteFile();
                return;
              }
              if(this.image.height > imageMaxHeight) {
                this.imageError = `The image height (${this.image.height}) is too much (max is ${imageMaxHeight}).`;
                this.deleteFile();
                return;
              }
            }
            //imageTag.src = evt.target.result;
            this.showImageModal = true;
            this.imgSrc = evt.target.result;
            // rebuild cropperjs with the updated source
            console.log("rebuild cropperjs with the updated source: " + evt.target.result);
            this.$refs.cropper.replace(evt.target.result);
          }

          reader.onerror = evt => {
            console.error(evt);
          }
        } else {
          alert('Sorry, FileReader API not supported - Try updating your browser to the latest version.');
        }
      },

      uploadFiles() {
        this.isLoading = true;
        /*
        let e = this.imageFile;
        */

        if (this.imagesList.length == 0) {
          //const downloadURL = null;
          console.log("downloadURLempty: ");
          this.createPost();
        } else {
          for (let i = 0; i < this.imagesList.length; i++){
            //imageUploadFileCurrent = this.imagesList[i].imageUploadFile;

            //let e = this.imagesList[i].imageUploadFile;
            let e = this.imagesList[i].imageUploadCropped;

            if(e != null) {
              const file = e;
              console.log("upload file: " + file.name);
              var randonNumber = Math.floor(Math.random()*(10000000-1)+0);
              console.log("randonNumber: " + randonNumber);
              
              fb.storage
                .ref("images/" + randonNumber + file.name)
                .put(file)
                .then(response => {
                  response.ref.getDownloadURL().then(downloadURL => {
                    //this.createPost(downloadURL);
                    console.log("downloadURLfull: " + downloadURL);

                    console.log("[i]] " + [i]);
                    console.log("this.imagesList.length: " + this.imagesList.length);

                    if ([i] == 0){
                      this.post.imageUrl1 = downloadURL;
                    } else if ([i] == 1) {
                      this.post.imageUrl2 = downloadURL;
                    }
                    if ([i] == (this.imagesList.length - 1)){
                      console.log("imageUrl1: " + this.post.imageUrl1);
                      console.log("imageUrl2: " + this.post.imageUrl2);
                      console.log("completed and call function: " + i);
                      this.createPost();
                    }
                    //return downloadURL;
                  });
                })
                .catch(err => {
                  console.log(err);
                  this.snackbarError();
                  this.isLoading = false;
                });
            }
              
          }
        }
          /*
          } else {
            const downloadURL = null;
            console.log("downloadURLempty: " + downloadURL);
            return downloadURL;
            //this.createPost(downloadURL);
          }*/
      },
      /*
      uploadImageArray: function() {
        console.log('images to upload: ' + this.imagesList.length);

        for (let i = 0; i < this.imagesList.length; i++){
          console.log("list item: " + this.imagesList[i].imageUploadFileNumberIncrement);
          imageUploadFileCurrent = this.imagesList[i].imageUploadFile;
          //let imageUploadedURL = this.uploadFile(imageUploadFileCurrent);
          console.log("imageUploadedURL: " + this.uploadFile(imageUploadFileCurrent));
          //this.imagesUploadedList.push({ imageUploadURL: this.uploadFile(imageUploadFileCurrent )});
        }
      },

      //uploadFile(e) {
      uploadFile: function(imageUploadFileCurrent) {
        this.isLoading = true;
        
        //let e = this.imageFile;
        
        let e = imageUploadFileCurrent;
        
        if(e != null) {
          const file = e;
          console.log("upload file: " + file.name);
          var randonNumber = Math.floor(Math.random()*(10000000-1)+0);
          console.log("randonNumber: " + randonNumber);
          
          fb.storage
            .ref("images/" + randonNumber + file.name)
            .put(file)
            .then(response => {
              response.ref.getDownloadURL().then(downloadURL => {
                //this.createPost(downloadURL);
                console.log("downloadURLfull: " + downloadURL);
                return downloadURL;
              });
            })
            .catch(err => {
              console.log(err);
              this.snackbarError();
              this.isLoading = false;
            });
        } else {
          const downloadURL = null;
          console.log("downloadURLempty: " + downloadURL);
          return downloadURL;
          //this.createPost(downloadURL);
        }
      },*/

      /*
      setImage(e) {
        const file = e.target.files[0];
        if (!file.type.includes('image/')) {
          alert('Please select an image file');
          return;
        }
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            // rebuild cropperjs with the updated source
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      */

      initCropper() {
        this.cropImage();
      },

      cropImage() {
        let uploadCropNumber = this.imagesList.length;
        let e = null;

        this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
        e = this.cropImg;

        let arrayIndex = this.imagesList.length - 1;

        this.$set(this.imagesList[arrayIndex], 'imageSetCropped', this.$refs.cropper.getCroppedCanvas().toDataURL());

        if (this.imageFile.name != null){
          let originalFileName = this.imageFile.name;
          //overwrite original uploaded file with cropped file
          this.imageFile = this.dataURLtoFile(e, originalFileName);
          let blobFileName = this.imageFile.name;
          this.cropImgBlob = blobFileName;

          console.log("image file name overwrite");
          this.$set(this.imagesList[arrayIndex], 'imageUploadCropped', this.imageFile);

        }
      },
      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      },
      /*
      rotate() {
        this.$refs.cropper.rotate(90);
      },
      */
      snackbarSuccess() {
        this.$snackbar.open({
          duration: 4000,
          message: this.$t("post.snackbar-success"),
          type: "is-success",
          position: "is-bottom",
          actionText: this.$t("post.snackbar-error-action"),
          class: "has-background-dark",
          queue: false,
          onAction: () => {
            this.$router.push("/post");
          }
        });
      },
      snackbarError() {
        this.$snackbar.open({
          duration: 4000,
          message: this.$t("post.snackbar-error"),
          type: "is-info",
          position: "is-bottom",
          actionText: this.$t("post.snackbar-error-action"),
          queue: false,
          onAction: () => {
            this.$router.push("/posts");
          }
        });
      },
      //CleaveJS
      onInput(event) {
        this.rawValue = event.target._vCleave.getRawValue()
        this.value = event.target._vCleave.getFormattedValue()
      },
    },
    filters: {
      formatDate(val) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      },
      trimLength(val) {
        if (val.length < 200) {
          return val;
        }
        return `${val.substring(0, 200)}...`;
      }
    },
  };
</script>